import React from 'react';
import TableSkeleton from '../../Component/TableSkeleton';
import { CircularProgress } from '@mui/material';
import
{
  People as PeopleIcon,
  Email as EmailIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import LeadsTableStyles from './LeadsTableStyles';

const LeadsTable = ( {
  data,
  loading,
  columns,
  emptyMessage = 'No data found',
  skeletonRows = 5,
  skeletonCols = 3,
} ) =>
{

  console.log("data--" , data);
  const renderEmptyState = () => (
    <div
      style={{
        minHeight: '300px',
        height: '40vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="empty-state-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          maxWidth: '400px',
        }}
      >
        <div
          style={{
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '2px dashed #dee2e6',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
          }}
        >
          {emptyMessage === 'No leads found' ? (
            <PeopleIcon style={{ fontSize: '48px', color: '#6c757d' }} />
          ) : emptyMessage === 'No emails found' ? (
            <EmailIcon style={{ fontSize: '48px', color: '#6c757d' }} />
          ) : (
            <CheckCircleIcon style={{ fontSize: '48px', color: '#6c757d' }} />
          )}
        </div>
        <div
          style={{
            color: '#495057',
            fontSize: '20px',
            fontWeight: '600',
            marginBottom: '4px',
            textAlign: 'center',
          }}
        >
          {emptyMessage}
        </div>
        <div
          style={{
            color: '#6c757d',
            fontSize: '15px',
            textAlign: 'center',
            maxWidth: '320px',
            lineHeight: '1.6',
          }}
        >
          {emptyMessage === 'No leads found'
            ? 'No leads have been added yet. Add your first lead to get started.'
            : emptyMessage === 'No emails found'
              ? 'No email contacts found. Connect your Outlook account to import contacts.'
              : 'No data available at the moment.'}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <LeadsTableStyles />
      <div className="rounded-lg overflow-hidden">
        <div
          className="table100 ver1 no-capitalize m-b-110"
          style={{ marginTop: '2rem' }}
        >
          <div className="table100-head">
            <table>
              <thead>
                <tr className="row100 head">
                  {columns.map( ( column, index ) => (
                    <th
                      key={index}
                      className={`cell100 column${index + 1}`}
                      style={{
                        width: column.width || 'auto',
                        textAlign: column.align || 'left',
                      }}
                    >
                      {column.header}
                    </th>
                  ) )}
                </tr>
              </thead>
            </table>
          </div>
          {loading ? (
            <div style={{ width: '100%' }}>
              <TableSkeleton
                rowsCount={skeletonRows}
                colsCount={skeletonCols}
              />
            </div>
          ) : data.length === 0 ? (
            renderEmptyState()
          ) : (
            <div className="table100-body js-pscroll ps ps--active-y table-scrollable" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
              <table>
                <tbody>
                  {data.map( ( row, rowIndex ) => (
                    <tr
                      key={row.id || row.email || rowIndex}
                      className="row100 body"
                    >
                      {columns.map( ( column, colIndex ) => (
                        <td
                          key={colIndex}
                          className={`cell100 column${colIndex + 1}`}
                          style={{
                            width: column.width || 'auto',
                            textAlign: column.align || 'left',
                          }}
                        >
                          {column.render ? column.render( row ) : row[ column.key ]}
                        </td>
                      ) )}
                    </tr>
                  ) )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LeadsTable;
